import { AlertTriangle, Check, X } from 'react-feather';
import { Fragment } from 'react';
// ** Custom Components
import Avatar from '@components/avatar';
import { Zoom, toast } from 'react-toastify';
// ** Toast Component
const ToastComponent = ({ title, icon, color }) => (
  <Fragment>
    <div className="toastify-header pb-0">
      <div className="title-wrapper">
        <Avatar size="sm" color={color} icon={icon} />
        <h6 className="toast-title">{title}</h6>
      </div>
    </div>
  </Fragment>
);
export const success = (title) => {
  return toast.success(<ToastComponent title={title} color="success" icon={<Check />} />, {
    icon: false,
    autoClose: 2000,
    hideProgressBar: true,
    closeButton: false
  });
};

export const error = (title) => {
  return toast.error(<ToastComponent title={title} color="danger" icon={<X />} />, {
    icon: false,
    autoClose: 2000,
    hideProgressBar: true,
    closeButton: false
  });
};

export const warning = (title) => {
  return toast.warning(
    <ToastComponent title={`Error: ${title}`} color="warning" Icon={AlertTriangle} />,
    {
      icon: false,
      autoClose: 1000,
      hideProgressBar: true,
      closeButton: true,
      theme: 'colored',
      transition: Zoom
    }
  );
};

export const info = (title) => {
  return toast.info(
    <ToastComponent title={`Error: ${title}`} color="#17A2B8" Icon={AlertTriangle} />,
    {
      icon: false,
      autoClose: 1000,
      hideProgressBar: true,
      closeButton: true,
      theme: 'colored',
      transition: Zoom
    }
  );
};